import React from 'react';
import { connect } from 'react-redux';
import styles from './portfolio.module.scss';
import { Helmet } from 'react-helmet';

const Portfolio = ({showHelmet = true, words}) => {
    const projects = [
        {
            name: 'Rehabilitat.es',
            href: 'https://rehabilitat.es/',
            stack: ['MongoDB', 'Express', 'React', 'Node.js'],
            description: `MERN stack ${words.website}`
        },
        {
            name: 'RDING',
            href: 'http://rding.es',
            stack: ['Next.js', 'NestJS', 'TypeScript', 'MySQL'],
            description: `Next.js + NestJS + TypeScript + MySQL ${words.website}`
        }
    ];

    return(
        <>
            {showHelmet && <Helmet>
                <meta 
                    name="keywords" 
                    content="portfolio, works"
                />
                <meta
                    name="description"
                    content="Portfolio of Arman Gharibyan"
                />
                <title>{words.portfolioTitle}</title>
            </Helmet>}
            <section className={styles.container}>
                <div className={styles.header}>
                    <div className={styles.kicker}>{words.portfolio}</div>
                    <h2 className={styles.title}>{words.portfolioTitle}</h2>
                </div>
                <div className={styles.grid}>
                    {projects.map((project) => (
                        <article key={project.name} className={styles.item}>
                            <div className={styles.itemTop}>
                                <div>
                                    <div className={styles.projectLabel}>Selected work</div>
                                    <a className={styles.link} href={project.href} target="_blank" rel="noopener noreferrer">{project.name}</a>
                                </div>
                                <a className={styles.visitLink} href={project.href} target="_blank" rel="noopener noreferrer">Open</a>
                            </div>
                            <div className={styles.stack}>
                                {project.stack.map((item) => (
                                    <span key={item} className={styles.stackItem}>{item}</span>
                                ))}
                            </div>
                            <div className={styles.info}>{project.description}</div>
                        </article>
                    ))}
                </div>
                <a className={styles.githubLink} href="https://github.com/ArmanGharibyan93" target="_blank" rel="noopener noreferrer">Explore more on GitHub</a>
            </section>
        </>
        
    )
}

const mapStateToProps = (state) => {
    return{
        words: state.main.words
    }
}

export default connect(mapStateToProps, {})(Portfolio)